<template>
  <div class="media-preview full-box">
    <!-- <CustomVideo
      v-if="dataSource && dataSource.linkUrl && checkVideo(dataSource.linkUrl)"
      :path="dataSource.linkUrl.includes('http') ? dataSource.linkUrl : `${appUrl}${dataSource.linkUrl}`"
      :hiddenControls="true"
      :handleVolume="volumeVal"
      @ended="handleEnded"
    /> -->
    <PreviewImage 
      v-if="dataSource && dataSource.linkUrl && checkImage(dataSource.linkUrl)"
      :pathView="dataSource.linkUrl.includes('http') ? dataSource.linkUrl : `${appUrl}${dataSource.linkUrl}`"
      :isFullSize="true"
    />
    <!-- <PreviewYoutube 
      v-else-if="dataSource && dataSource.linkUrl && checkYoutube(dataSource.linkUrl)"
      :pathView="dataSource.linkUrl"
      :autoplay="true"
      :mediaMore="isRelateMedia"
    /> -->
    <PreviewAudioPoster
      v-else-if="dataSource && dataSource.linkUrl && checkAudio(dataSource.linkUrl)"
      :pathView="isFullLink(dataSource.linkUrl) ? dataSource.linkUrl : `${appUrl}${dataSource.linkUrl}`"
      :autoPlay="true"
      :poster="dataSource.posterLink ? `${urlImg}/${dataSource.posterLink}` : imgThumbAudio"
      :hiddenControls="true"
      :handleVolume="volumeVal"
      @ended="handleEnded"
    />
    <CustomVideo
      v-else-if="dataSource && dataSource.linkUrl && checkVideo(dataSource.linkUrl)"
      :path="dataSource.linkUrl.includes('http') ? dataSource.linkUrl : `${appUrl}${dataSource.linkUrl}`"
      :hiddenControls="true"
      :handleVolume="volumeVal"
      @ended="handleEnded"
    />
  </div>
</template>

<script>
  import mixinsFiles from '@/components/content-files/mixinsFiles'
  // import PreviewVideo from '@/components/content-files/PreviewVideo.vue'
  // import PreviewPdf from '@/components/content-files/PreviewPdf.vue'
  // import Previewpptx from '@/components/content-files/Previewpptx.vue'
  import PreviewImage from '@/components/content-files/PreviewImage.vue'
  import PreviewYoutube from '@/components/content-files/PreviewYoutube.vue'
  // import PreviewAudio from '@/components/content-files/PreviewAudio.vue'
  // import PreviewBookImg from "@/components/content-files/PreviewBookImg.vue"
  import PreviewAudioPoster from "@/components/content-files/PreviewAudioPoster.vue"
  import CustomVideo from '@/components/content-files/PreviewVideoCustom.vue'
  import { APP_CONFIG } from '@/utils/constants'
  const img404 = require(`@/assets/images/img_404.jpg`)
  const imgThumbAudio = require(`@/assets/images/thumb-audio.png`)

  export default {
    name: 'PreviewMedia',
    mixins: [ mixinsFiles ],
    props: {
      dataSource: Object,
      isRelateMedia: Boolean,
      bookPageLinkGroup: Number,
      isPublish: Number,
      volumeVal: String
    },
    components: {
      // PreviewVideo,
      // Previewpptx,
      PreviewImage,
      PreviewYoutube,
      // PreviewAudio,
      // PreviewBookImg,
      PreviewAudioPoster,
      CustomVideo
    },
    data () {
      return {
        appUrl: APP_CONFIG.bookCdnUrl,
        urlImg: APP_CONFIG.urlPlatformCmsImg,
        img404,
        imgThumbAudio
        // cdnUrl: APP_CONFIG.cdnUrl,
        // imgUrlCms: APP_CONFIG.urlPlatformCmsImg,
      }
    },
    watch: {
      dataSource (newVal) {
        newVal && this.checkFileTypeShowBtnsMedia()
      }
    },
    mounted () {
      this.checkFileTypeShowBtnsMedia()
    },
    methods: {
      checkFileTypeShowBtnsMedia () {
        const isTypeVideoAudio = this.dataSource && this.dataSource.linkUrl && (this.checkVideo(this.dataSource.linkUrl) || this.checkAudio(this.dataSource.linkUrl))
        // console.log('checktype: ', isTypeVideoAudio)
        if (!isTypeVideoAudio) {
          setTimeout(() => {
            this.handleEnded()
          }, 5000)
        }
        this.$emit('checkTypeMedia', isTypeVideoAudio)
      },

      handleEnded () {
        this.$emit('ended', true)
      }
      // handleMouseWorking (val) {
      //   this.$emit('mouseWorking', val)
      // }
    }
  }
</script>

<style lang="scss">
  .media-preview img {
    max-height: 100vh!important;
  }
</style>
